var ActionType;
(function (ActionType) {
    ActionType["Search"] = "Search";
    ActionType["Account"] = "Account";
    ActionType["Currency"] = "Currency";
    ActionType["Language"] = "Language";
    ActionType["ShoppingCart"] = "ShoppingCart";
})(ActionType || (ActionType = {}));

export { ActionType as A };
//# sourceMappingURL=types-nwm8HIz7.js.map
